/*
 * @Description:ETC成本通行交易
 * @Author: WangYuhan
 * @Date: 2022-12-26 16:04:45
 * @LastEditTime: 2023-01-04 15:49:15
 * @LastEditors: WangYuhan
 */
import { waybillEtcItemPageList } from '@/api/account';

// const storeModelName = 'ownerAccountsModule';
const state = {
  waybillNo: '',
  postParams: {
    page: 1,
    size: 10,
  },
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '序号',
        prop: 'sequence',
        checked: 1,
        width: 40,
        sortable: true,
      },
      {
        label: '高速入口',
        prop: 'enterAddress',
        checked: 1,
        width: 160,
        sortable: true,
      },
      {
        label: '上高速时间',
        prop: 'enterTime',
        checked: 1,
        width: 125,
        sortable: true,
      },
      {
        label: '高速出口',
        prop: 'exportAddress',
        checked: 1,
        width: 160,
        sortable: true,
      },
      {
        label: '下高速时间',
        prop: 'exportTime',
        checked: 1,
        width: 125,
        sortable: true,
      },
      {
        label: '车牌号',
        prop: 'vehicleNo',
        checked: 1,
        width: 60,
        sortable: true,
      },
      {
        label: '消费金额',
        prop: 'tripExpenses',
        checked: 1,
        width: 80,
        sortable: true,
        slotName: 'sub-domain-tripExpenses',
      },
      {
        label: '卡号',
        prop: 'cardNumber',
        checked: 1,
        width: 120,
        sortable: true,
      },
    ],
    total: 0,
  },
};
const getters = {};

const actions = {
  getList: async context => {
    const { code, data } = await waybillEtcItemPageList(
      Object.assign(
        {},
        {
          waybillNo: context.state.waybillNo,
          page: context.state.postParams.page,
          size: context.state.postParams.size,
        },
      ),
    );
    if (code === 200) {
      data.records.forEach((item, index) => {
        item.sequence = index + 1;
      });
      context.commit('updateListData', {
        list: data.records,
        total: data.total,
      });
    }
  },
};

const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = Object.assign({}, state.listData, payload);
  },
  updateState(state, payload) {
    state[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
